import { useSortBy, useTable } from 'react-table';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

// Components
import { Illustration } from '@/components/composite/Illustration';
import TableBody from '@/components/pages/reports/components/Table/TableBody';
import TableHead from '@/components/pages/reports/components/Table/TableHead';
import TablePlaceholder from '@/components/pages/reports/components/Table/TablePlaceholder';

// static import for img blur placeholder
import IllustrationEn from './../../../../../../public/images/illustrations/illustrations-empty-en.webp';
import IllustrationEs from './../../../../../../public/images/illustrations/illustrations-empty-es.webp';
import IllustrationFr from './../../../../../../public/images/illustrations/illustrations-empty-fr.webp';

const TableReports = ({
    data,
    columns,
    isLoading,
    initialState = {},
    requestParams = {},
    setRequestParams = () => {
        /** */
    }
}) => {
    const { t } = useTranslation();
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
        {
            data,
            columns,
            initialState
        },
        useSortBy
    );

    return (
        <div className="scrollbar overflow-x-auto overflow-y-hidden">
            {!data?.length && !isLoading ? (
                <div className="flex min-h-[400px] w-full flex-col items-center justify-center text-sm text-icoGray-500 dark:text-icoDarkMode-wolf">
                    <Illustration
                        src={{ en: IllustrationEn, fr: IllustrationFr, es: IllustrationEs }}
                        height="280"
                        width="280"
                        className="max-w-[280px]"
                    />
                    <span>{t('reports:general.search_empty')}</span>
                </div>
            ) : (
                <table className="w-full min-w-[880px] table-fixed" {...getTableProps()}>
                    <TableHead
                        requestParams={requestParams}
                        setRequestParams={setRequestParams}
                        headerGroups={headerGroups}
                    />
                    {isLoading ? (
                        <TablePlaceholder />
                    ) : (
                        <TableBody
                            rows={rows}
                            prepareRow={prepareRow}
                            getTableBodyProps={getTableBodyProps}
                        />
                    )}
                </table>
            )}
        </div>
    );
};

TableReports.propTypes = {
    data: PropTypes.array,
    initialState: PropTypes.object,
    requestParams: PropTypes.object,
    setRequestParams: PropTypes.func,
    columns: PropTypes.array.isRequired
};

export default TableReports;
